/**
 * 프리뷰/템플릿 공통 포맷터 + 매핑 상수
 */

import { Car, Bus, Utensils, Shirt, Gift, Camera, Info } from 'lucide-react'

/** 빈 배열 상수 (불필요한 참조 변경 방지) */
export const EMPTY_ARRAY: never[] = []

/** 인사말 폰트 크기 프리셋 → px 매핑 */
export const GREETING_FONT_SIZE_MAP: Record<string, number> = {
  sm: 11,
  md: 12,
  lg: 14,
  xl: 16,
}

/** 폰트 패밀리 slug → CSS font-family 매핑 */
export const FONT_FAMILY_MAP: Record<string, string> = {
  pretendard: 'Pretendard, sans-serif',
  'noto-sans': '"Noto Sans KR", sans-serif',
  'noto-serif': '"Noto Serif KR", serif',
  'gowun-batang': '"Gowun Batang", serif',
  'nanum-myeongjo': '"Nanum Myeongjo", serif',
  'kopub-batang': '"KoPub Batang", serif',
}

/** 텍스트 스케일 → CSS font-size 배율 */
export const TEXT_SCALE_MAP: Record<string, number> = {
  sm: 0.9,
  md: 1,
  lg: 1.1,
}

/** 페이드인 속도 slug → CSS duration 매핑 */
export const FADE_SPEED_MAP: Record<string, string> = {
  slow: '800ms',
  normal: '500ms',
  fast: '300ms',
  none: '0ms',
}

/** 안내사항 아이콘 slug → lucide 컴포넌트 매핑 */
export const NOTICE_ICON_MAP: Record<string, typeof Car> = {
  parking: Car,
  shuttle: Bus,
  meal: Utensils,
  dress: Shirt,
  gift: Gift,
  photo: Camera,
  etc: Info,
}

/** 날짜 문자열을 한국어 예식일 형식으로 포맷 */
export function formatWeddingDate(dateStr: string | undefined): string | null {
  if (!dateStr) return null
  try {
    const d = new Date(dateStr)
    const days = ['일', '월', '화', '수', '목', '금', '토']
    const y = d.getFullYear()
    const m = d.getMonth() + 1
    const day = d.getDate()
    const dow = days[d.getDay()]
    const h = d.getHours()
    const min = d.getMinutes()
    const ampm = h < 12 ? '오전' : '오후'
    const h12 = h % 12 || 12
    return `${y}년 ${m}월 ${day}일 ${dow}요일 ${ampm} ${h12}시${min > 0 ? ` ${min}분` : ''}`
  } catch {
    return null
  }
}

/** displayMode에 따른 부모 이름 문자열 생성 (故人 표시 포함) */
export function formatParentNames(
  person:
    | {
        fatherName?: string
        motherName?: string
        displayMode?: string
        isDeceased?: { father?: boolean; mother?: boolean }
      }
    | undefined,
): string | null {
  if (!person) return null
  const mode = person.displayMode ?? 'full_names'
  const dec = person.isDeceased
  const father = person.fatherName?.trim()
  const mother = person.motherName?.trim()
  const fLabel = father ? (dec?.father ? `故 ${father}` : father) : undefined
  const mLabel = mother ? (dec?.mother ? `故 ${mother}` : mother) : undefined

  switch (mode) {
    case 'full_names':
      if (fLabel && mLabel) return `${fLabel} · ${mLabel}`
      return fLabel || mLabel || null
    case 'single_parent_father':
      return fLabel || null
    case 'single_parent_mother':
      return mLabel || null
    case 'self_only':
      return null
    default:
      return null
  }
}
